import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    NotificationDispatchesRequestModel,
    NotificationDispatchModel,
    NotificationListItemModel,
    NotificationListRequestModel,
    NotificationModel,
    NotificationSaveModel,
} from 'core/models/notification.model';
import { ResponseModel } from 'core/models/response.model';
import { ApiListDataService } from './api.list-data.service';

type QueryParamValue = string | number | boolean | ReadonlyArray<string | number | boolean>;

@Injectable({
    providedIn: 'root',
})
export class ApiAdminNotificationsService extends ApiListDataService<
    NotificationListItemModel,
    NotificationModel
> {
    constructor(http: HttpClient) {
        super(http, '/Admin/Notifications/');
    }

    public getList(
        params: NotificationListRequestModel,
    ): Observable<ResponseModel<NotificationListItemModel>> {
        return this.get<ResponseModel<NotificationListItemModel>>('', this.toHttpParams(params));
    }

    public getDispatches(
        id: number,
        params: NotificationDispatchesRequestModel,
    ): Observable<ResponseModel<NotificationDispatchModel>> {
        return this.get<ResponseModel<NotificationDispatchModel>>(
            `${id}/Dispatches`,
            this.toHttpParams(params),
        );
    }

    public createNotification(model: NotificationSaveModel): Observable<NotificationModel> {
        return this.post<NotificationModel>('', JSON.stringify(model));
    }

    public updateNotification(
        id: number,
        model: NotificationSaveModel,
    ): Observable<NotificationModel> {
        return this.put<NotificationModel>(String(id), JSON.stringify(model));
    }

    private toHttpParams<T extends object>(params: T): HttpParams {
        return Object.entries(params as Record<string, QueryParamValue | null | undefined>).reduce(
            (httpParams, [key, value]) => {
                if (value === null || value === undefined || value === '') {
                    return httpParams;
                }

                if (Array.isArray(value)) {
                    return value.reduce(
                        (accumulated: HttpParams, item) => accumulated.append(key, String(item)),
                        httpParams,
                    );
                }

                return httpParams.set(key, String(value));
            },
            new HttpParams(),
        );
    }
}
